/**
 * Suppress unhandled promise rejections from Inertia network errors.
 *
 * When a navigation request fails at the network level (e.g. the user is
 * offline or the request is interrupted), Inertia core fires the cancelable
 * `inertia:exception` event. If the event is not cancelled, Inertia returns
 * `Promise.reject(error)` from its internal request chain, which surfaces as
 * an unhandled promise rejection — reported by Sentry's global
 * `onunhandledrejection` handler as an AxiosError with code ERR_NETWORK.
 *
 * Cancelling the event tells Inertia to swallow the rejection rather than
 * re-throw it. This matches the same approach used for `inertia:invalid` in
 * suppressInertiaInvalidModal: cancel the event to prevent an unhelpful
 * unhandled-rejection alert while still allowing per-visit error handling and
 * any Sentry breadcrumb capture to occur upstream.
 */
export function suppressInertiaNetworkErrors(): void {
  document.addEventListener('inertia:exception', (event) => {
    event.preventDefault();
  });
}
